import { render, staticRenderFns } from "./MetaCompany.vue?vue&type=template&id=bcade9bc&scoped=true&"
import script from "./MetaCompany.vue?vue&type=script&lang=ts&"
export * from "./MetaCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcade9bc",
  null
  
)

export default component.exports